export default __webpack_public_path__ + "static/media/home-section-04.c7a5ef99.webp";